<script>
import { mapState, mapGetters } from "vuex";

import Loader from "@/components/_base/Loader";
import Order from "./Order";
import Cycle from "./Cycle";

export default {
  components: {
    Loader,
    Order,
    Cycle
  },

  computed: {
    ...mapGetters("payable", ["noPayable", "isPayableOrder", "isPayableCycle"])
  }
};
</script>

<template>
  <div class="card">
    <transition name="zoom" mode="out-in">
      <div v-if="noPayable" class="loading">
        <Loader indeterminate />
        <p>Carregando informações do pedido</p>
      </div>

      <Order v-else-if="isPayableOrder" />
      <Cycle v-else-if="isPayableCycle" />
    </transition>
  </div>
</template>

<style scoped>
.card {
  margin-right: 0;
  margin-bottom: 12px;
  padding: 16px;
}

.loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/Checkout/Payable/Index.vue